var CONFUSEDCMS = CONFUSEDCMS || {};

(function ($) {

    CONFUSEDCMS.priceIndex = function () {

        if (window.innerWidth > 600) {
            $(window).scroll(function () {
                $('.img--infographic').each(function (e) {

                    var image = $(this),
                        imageSrc = image.attr('src'),
                        imageOffset = $(this).offset().top,
                        imageHeight = $(this).outerHeight(),
                        windowHeight = $(window).height(),
                        windowScroll = $(window).scrollTop();
                    if (!image.hasClass('active')) {
                        if (windowScroll > (imageOffset + imageHeight - windowHeight)) {
                            image.css('opacity', '1');
                            image.attr('src', imageSrc);
                            image.addClass('active');
                        } else {
                            $(this).css('opacity', '0');
                        }
                    }
                });
            });
        }

        $('.expanded-image-button').click(function (e) {
            e.preventDefault();
            $(this).closest('.container').nextAll('.expanded-image-modal').fadeIn(300);
            $('.dimmer').fadeIn(300);
        });

        $('.expanded-image-modal__inner__close').click(function (e) {
            e.preventDefault();
            $(this).closest('.expanded-image-modal').fadeOut(300);
            $('.dimmer').fadeOut(300);
        });

        $('.video__controls a').click(function () {
            $('.video-header').hide();
        });

    };
})(window.jQuery);